/**
 * The hooks the guided tour (features/tour) reads from the DOM. Screens only
 * mark themselves; they never import the tour.
 *
 *  - `data-tour="<anchor>"` names a region a tour step can point at. It goes
 *    on a container that exists in every state (a DataState section, a bar,
 *    a nav group), never on content that only exists once data has loaded.
 *  - `data-tour-state` on that region says which of the four states it is in.
 *    DataState sets it; a region with hand-built states sets it itself.
 *  - `data-tour-page` on a screen's root says what the whole screen shows
 *    when it replaces its regions (still loading, an error, nothing to show).
 */
export type RegionState = 'loading' | 'error' | 'empty' | 'content';
export type PageState = 'loading' | 'error' | 'empty' | 'ready';

export const regionAttrs = (anchor: string | undefined, state: RegionState) => ({
  ...(anchor ? { 'data-tour': anchor } : {}),
  'data-tour-state': state,
});

export const pageAttrs = (state: PageState) => ({ 'data-tour-page': state });
